import React, { useEffect, useState } from "react";
import Styles from "./Payouts.module.css";
import { Modal } from "@mui/material";
import { Close } from "@mui/icons-material";
import ConfirmationModal from "../../../../commons/ConfirmationModal/ConfirmationModal";
import { getContractPayouts } from "../../../../Services/Payments/PaymentApi";
import { ErrorMessage } from "../../../../commons/Toast/ErrorMessage";

const Payouts = ({
  open,
  handleClose,
  list,
  handlePayoutsSubmit,
  viewOnly = false,
  id,
  repId,
}) => {
  console.debug("1234", repId);
  const [accumulated, setAccumulated] = useState([]);
  const [confirmModal, setConfirmModal] = useState({
    status: false,
    data: "Do you want to proceed with this value?",
    note: "Once done, payment will be transferred  through bank using NOCA.",
  });
  console.debug("accumulated", accumulated);
  useEffect(() => {
    if (viewOnly) {
      handleViewPayouts();
      return;
    }
    const rawData = list || [];

    const processData = (data) => {
      // 1. Use an object map to group by the unique combination of fromUser + toUser
      const groups = data.reduce((acc, item) => {
        // Create a unique key
        const key = `${item.fromUser}_${item.toUser}`;

        if (!acc[key]) {
          // --- LOGIC ADDED HERE ---
          // Check if IDs are the same to determine status
          const currentToUserId = item.toUserId || 0;
          const status =
            item.fromUserId === currentToUserId ? "REFUND" : "DEBIT";
          // ------------------------

          // Initialize the group object if it doesn't exist
          acc[key] = {
            fromUser: item.fromUser,
            toUser: item.toUser,
            fromUserId: item.fromUserId,
            toUserId: currentToUserId,
            transactionType: status, // New key added
            totalAmount: 0,
            items: [],
            repScheduleId: list?.[0]?.repScheduleId,
          };
        }

        // Accumulate the amount
        acc[key].totalAmount += item.checkerInputChargeAmount || 0;

        // Push the specific charge to the items array
        acc[key].items.push(item);

        return acc;
      }, {});

      // 2. Convert the map values back into a single array
      return Object.values(groups);
    };

    setAccumulated(processData(rawData));
  }, [list]); // Recommendation: Add 'list' to dependency array so it updates when data changes

  const handleModalSubmit = () => {
    handlePayoutsSubmit({
      list: accumulated,
    });
  };

  const handleViewPayouts = async () => {
    let res = await getContractPayouts({ id, repid: repId });
    if (res?.data?.code === 200) {
      setAccumulated(res?.data?.data);
    } else {
      ErrorMessage(res?.data?.message || res?.data?.error);
    }
    console.debug("res1", res);
  };

  return (
    <>
      {confirmModal?.status && (
        <ConfirmationModal
          open={confirmModal?.status}
          data={confirmModal?.data}
          handleClose={() =>
            setConfirmModal({ status: false, data: "", note: "", type: null })
          }
          header={"Confirmation"}
          note={confirmModal?.note}
          handleSubmit={handleModalSubmit}
          commentBox={confirmModal?.type === "reject"}
        />
      )}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <div className={`popupModal ${Styles.payoutsModal}`}>
          <div className={`display_flex_row modalHeading `}>
            <div className="headingText">Payouts</div>
            <Close
              style={{ fontSize: 24, color: "#777777", cursor: "pointer" }}
              onClick={handleClose}
            />
          </div>
          <div className={Styles.payoutMainContainer}>
            <div className={`tableHeading display_flex_row`}>
              <div style={{ width: "20%" }}>From</div>
              <div style={{ width: "20%" }}>To</div>
              <div style={{ width: "30%" }}>Total Amount (₹)</div>
              <div style={{ width: "20%" }}>Type</div>
            </div>
            <div className={`scroll_bar_y ${Styles.payoutsScrollContianer}`}>
              {accumulated?.length === 0 ? (
                <div className="pending">Payout Not Generated</div>
              ) : accumulated?.length > 0 ? (
                accumulated?.map((ele) => (
                  <div className="display_flex_row tableDetails">
                    <div style={{ width: "20%" }}>{ele?.fromUser}</div>
                    <div style={{ width: "20%" }}>{ele?.toUser}</div>
                    <div style={{ width: "30%" }}>
                      {ele?.totalAmount || ele?.transferAmount}
                    </div>
                    <div style={{ width: "20%" }}>
                      {viewOnly ? (
                        <>{ele?.transactionType}</>
                      ) : (
                        <>
                          {ele?.fromUser === ele?.toUser
                            ? "Refund"
                            : "Transfer"}
                        </>
                      )}
                    </div>
                  </div>
                ))
              ) : (
                <div className="pending">Loading ...</div>
              )}
            </div>
          </div>
          {!viewOnly && (
            <div
              className={`activeButton ${Styles.continueButton}`}
              onClick={() =>
                setConfirmModal({
                  status: true,
                  data: "Do you want to proceed with this value?",
                  note: "Once done, payment will be transferred  through bank using NOCA.",
                })
              }
            >
              Confirm
            </div>
          )}
        </div>
      </Modal>
    </>
  );
};

export default Payouts;
